import {initParallaxSection} from "../components/parallax-section";

export function initBankiLanding() {
    if (!$('#banki_landing').length) return;
    initParallaxSection();
}